import Icon from '../Icon.vue'

Icon.register({
  'pptx': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M10 5V2.824L12.176 5H10zm.003-5H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2V2h6v4a1 1 0 001 1h4v2h2V4.997L10.003 0z'
      },
      {
        d: 'M5.25 11.126h-.693v1.008h.693c.336 0 .532-.245.532-.504 0-.26-.196-.504-.532-.504zm.057 2.107h-.75v1.78H3.331v-4.987h1.976c1.106 0 1.701.785 1.701 1.604 0 .819-.595 1.603-1.701 1.603zM9.499 11.126h-.693v1.008h.693c.336 0 .532-.245.532-.504 0-.26-.196-.504-.532-.504zm.057 2.107h-.75v1.78H7.58v-4.987h1.976c1.106 0 1.701.785 1.701 1.604 0 .819-.595 1.603-1.701 1.603zM14.127 11.118v3.895H12.9v-3.895h-1.225v-1.092h3.678v1.092h-1.226zM18.6 15.013l-.82-1.534-.82 1.534h-1.4l1.555-2.557-1.456-2.43h1.393l.729 1.408.728-1.407h1.394l-1.457 2.429L20 15.013h-1.4z'
      }
    ]
  }
})
